import Checkbox from "../Checkbox";
import Typography from "../Typography";

export default function ItemSelect({ index, item, setValorInput, valorInput, checkbox, onClick }) {
    return (
        <div className={`w-full pb-1 ${index != 0 ? "pt-[0.75rem]" : "pt-1"} cursor-pointer justify-start items-center inline-flex`} key={item.valor}>
            <Checkbox
                onClick={onClick}
                component="medio"
                checked={checkbox ? valorInput?.find(a => a.valor == item.valor) : valorInput == item.valor}
                value={item.valor}
                select={!checkbox}
                onChange={(e) => {
                    if (checkbox) {
                        let values = valorInput?.map(v => v?.valor)
                        if (values.indexOf(e) > -1) setValorInput(l => l.filter(i => i.valor != item.valor));
                        else setValorInput(oldArray => [...oldArray, item]);
                    } else setValorInput(item.valor)
                }}>
                <Typography component={"body"}>{item.titulo}</Typography>
            </Checkbox>

        </div>
    )
}